import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import './ShiftApplicantsComponent.scss';
import applicantLogic from 'pages/ScheduleCalendar/duck/applicantLogic';
import ShiftApplicantRow from './ShiftApplicantRow';
import presenter from 'pages/ScheduleCalendar/duck/presenter';
import ShiftApplicantCommentsContainer from './ShiftApplicantCommentsContainer';
import service from 'pages/ScheduleCalendar/duck/service';
import { Mixpanel } from 'helpers/Mixpanel';
import displayLogic from 'pages/ScheduleCalendar/duck/displayLogic';

export function ShiftApplicantsComponent({
  applicants,
  approveApplicantDispatch,
  denyApplicantDispatch,
  presentedShift,
  shiftMatrix,
  weekRangeStart,
  handleTooltipShow,
  handleTooltipHide,
  selectedApplicantId,
  setSelectedApplicantId,
  selectedApplicant,
  setSelectedApplicant,
  showingComments,
  setShowingComments,
  applicantToShowCommentsFor,
  setApplicantToShowCommentsFor,
  prepareToApproveApplicant,
  prepareToDenyApplicant,
}) {

  const approveSelectedApplicant = () => {
    const applicant = selectedApplicant;
    if (applicant != null) {
      // approveApplicantDispatch(applicant.schedule_element_id, applicant); 
      // Mixpanel.track('Approve applicant', { applicantId: applicant.id });
      prepareToApproveApplicant(presentedShift, applicant);
    }
  }

  const denySelectedApplicant = () => {
    const applicant = selectedApplicant;
    if (applicant != null) {
      // denyApplicantDispatch(applicant.schedule_element_id, applicant); 
      // Mixpanel.track('Deny applicant', { applicantId: applicant.id });
      prepareToDenyApplicant(presentedShift, applicant);
    }
  }

  const selectApplicant = (applicant) => {
    setSelectedApplicant(applicant);
    setSelectedApplicantId(applicant.id);
  }

  const showCommentsForApplicant = (applicant) => {
    setApplicantToShowCommentsFor(applicant);
    setShowingComments(true);
  }

  const showApplicantList = () => {
    setApplicantToShowCommentsFor(null);
    setShowingComments(false);
  }

  const applicantRow = (applicant) => {
    const selected = (selectedApplicant?.id == applicant.id);
    const hasConflict = shiftMatrix && weekRangeStart && service.applicantHasOtherShifts(applicant, presentedShift, weekRangeStart, shiftMatrix)

    return <ShiftApplicantRow
      key={applicant.id}
      applicant={applicant}
      selectApplicant={selectApplicant}
      presentedShift={presentedShift}
      isHighlighted={selected}
      showCommentsForApplicant={showCommentsForApplicant}
      hasConflict={hasConflict}
      handleTooltipShow={handleTooltipShow}
      handleTooltipHide={handleTooltipHide} />
  }

  const autoSelectFirstValidApplicant = () => {
    if (selectedApplicantId != null && selectedApplicant != null && selectedApplicant.id == selectedApplicantId && selectedApplicant.schedule_element_id == presentedShift.id) {
      console.log('skip selectedApplicantId != null');
      return;
    }
    const autoSelectedApplicantId = applicantLogic.applicantIdToBeAutoSelected(presentedShift, applicants);
    if (autoSelectedApplicantId != null) {
      const applc = applicantLogic.getApplicantById(selectedApplicantId, applicants);
      setSelectedApplicant(applc);
      setSelectedApplicantId(autoSelectedApplicantId);
    }
  }

  const populateApplicantFromId = () => {
    const applc = applicantLogic.getApplicantById(selectedApplicantId, applicants);
    if (applc?.status != selectedApplicant?.status) {
      setSelectedApplicant(applc);
    }
  }

  const pendingRows = applicantLogic.pendingApplicants(applicants).map((applicant) => { return applicantRow(applicant); });
  const approvedRows = applicantLogic.approvedApplicants(applicants).map((applicant) => { return applicantRow(applicant); });
  const deniedRows = applicantLogic.deniedApplicants(applicants).map((applicant) => { return applicantRow(applicant); });

  const pendingX = presenter.pendingX(pendingRows.length);
  const approvedX = presenter.approvedX(approvedRows.length);
  const deniedX = presenter.deniedX(deniedRows.length);

  autoSelectFirstValidApplicant();
  populateApplicantFromId();

  const shouldShowCTAForSelectedApplicant = displayLogic.shouldShowCTAForSelectedApplicant(selectedApplicant);
  const classNameForManagedApplicant = displayLogic.classNameForManagedApplicant(selectedApplicant);
  const managedText = presenter.textForManagedApplicant(selectedApplicant);

  return (<div className='shift-applicants-container'>
    {showingComments == false && <div>
      <div className='applicants-list'>
        <label className='applicant-row-header'>{pendingX}</label>
        {pendingRows}

        <label className='applicant-row-header'>{approvedX}</label>
        {approvedRows}

        <label className='applicant-row-header'>{deniedX}</label>
        {deniedRows}
      </div>
      <div className='action-buttons'>
        {shouldShowCTAForSelectedApplicant == true && <button className={'deny-button ' + (selectedApplicant != null ? ' normal-deny' : 'grayed-out')} onClick={denySelectedApplicant}> Deny </button>}
        {shouldShowCTAForSelectedApplicant == true && <button className={'approve-button ' + (selectedApplicant != null ? 'normal-approve' : 'grayed-out')} onClick={approveSelectedApplicant}> {'Approve' + presenter.getApplicantFirstName(selectedApplicant)}</button>}
        {shouldShowCTAForSelectedApplicant == false && <span className={'managed-applicant ' + classNameForManagedApplicant}>{managedText}</span>}
      </div>
    </div>}

    {showingComments == true &&
      <ShiftApplicantCommentsContainer
        presentedShift={presentedShift}
        applicant={applicantToShowCommentsFor}
        handleBackButtonClick={showApplicantList}
      />}
  </div>
  );
}

export default injectIntl(ShiftApplicantsComponent);
